<template>
  <div class="card" id="grafico-funnels-vsl">
    <div class="funnels">
      <vue-funnel-graph :width="width" :height="height" :labels="labels" :values="values" :colors="colors" :sub-labels="subLabels" :direction="direction" :gradient-direction="gradientDirection" :animated="true" :display-percentage="true"></vue-funnel-graph>
    </div>
  </div>
</template>

<script>
import { VueFunnelGraph } from 'vue-funnel-graph-js'

export default {
  components: {
    VueFunnelGraph,

  },
  props: {
    ObjsFunnelGeral: {
      type: [Object, Array],
      default: () => [],
    },
  },
  data() {
    return {
      labels: [],
      subLabels: [],
      values: [],
      colors: [],
      direction: 'horizontal',
      gradientDirection: 'horizontal',
      height: 300,
      width: 1200,
      dataSetNum: 1,
    }
  },
  watch: {
    ObjsFunnelGeral(newVal, oldVal) {
      this.useDataSet()
    },
  },

  mounted() {
    this.useDataSet()
  },
  methods: {
    useDataSet() {
      this.labels = ['Visualizações', 'Plays', 'Play Rate', 'Engajamento']
      this.subLabels = []
      this.values = this.ObjsFunnelGeral
      this.colors = ['#FF4589', '#FF5050']
    },
  },
}
</script>
<style scoped>

.card{
  background-color: #393862;
  overflow-x: hidden;
}

#grafico-funnels-vsl {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.funnels {
  height: 560px;
  margin-top: 16px;
}

.funnel:not(.svg-funnel-js--vertical) {
  transition: transform 0.3s ease;
  transform: translateY(60px);
}

</style>
